import Config from 'APP/Config'
import { LoginStrategy } from 'APP/Config/types'
import { SupportedLocales } from 'APP/Models/Locale'

// The LOGIN_STRATEGIES entry marked emphasis: 'primary' — the build's main SSO strategy
// (e.g. Sun Life). Undefined for builds with no primary strategy (e.g. standard Dialogue).
export const getPrimaryLoginStrategy = (): LoginStrategy | undefined =>
  Config?.LOGIN_STRATEGIES
    ? Object.values(Config.LOGIN_STRATEGIES).find((strategy) => strategy?.emphasis === 'primary')
    : undefined

export const getBrandConfig = (brandId: string, locale: SupportedLocales = 'en') => {
  const brandMap = Config.BRAND_MAP
  const brandKey =
    Config.BRAND_VERSION && brandId === Config.BRAND_ID
      ? `${brandId}_${Config.BRAND_VERSION}`
      : brandId
  const brandConfig = brandMap && brandMap[brandKey]
  const url =
    brandConfig && brandConfig.branchLinks && brandConfig.branchLinks[Config.PROD ? 'prod' : 'dev']

  return {
    url,
    appName: brandConfig && brandConfig.appName,
    productName: brandConfig && brandConfig.productName[locale],
  }
}
